import PropTypes from 'prop-types'
import { Heading } from '@leroy-merlin-br/backyard-react-ui'

import { useProfile } from 'catalog/hooks/use-profile'

import Product from '../Product'
import ShipmentModalities from '../ShipmentModalities'
import * as S from './styled'

const Section = ({
  freightCost,
  modalities,
  onRemove,
  products,
  type,
  updateProduct,
  services,
  regionId
}) => {
  const { profile } = useProfile()

  const titlesByType = {
    delivery: 'Entregamos para você',
    pickupInStore: profile.regionDriveThru
      ? 'Você retira no drive-thru da loja'
      : 'Você retira na loja',
    scanAndGo: 'Produtos que você escolheu'
  }

  return (
    <S.Wrapper>
      <S.Header>
        <Heading as="h2" size="giga" noMargin>{ titlesByType[type] }</Heading>
      </S.Header>

      <ShipmentModalities modalities={modalities} />

      <div>
        {products.map(product => (
          <Product
            key={product.id}
            updateProduct={updateProduct}
            onRemove={onRemove}
            shippingType={type}
            services={services}
            regionId={regionId}
            {...product}
          />
        ))}
      </div>
    </S.Wrapper>
  )
}

Section.propTypes = {
  type: PropTypes.oneOf(['delivery', 'pickupInStore', 'scanAndGo']).isRequired,
  onRemove: PropTypes.func.isRequired
}

export default Section
